import { Vertical } from 'component/Vertical'
import { observer } from 'mobx-react-lite'
import { BasicSelfiesPanel } from 'page/ProfileScreen/BasicSelfiesPanel/BasicSelfiesPanel'
import css from './BasicView.module.scss'

export const BasicView = observer(() => {
  return (
    <Vertical className={css.view}>
      <Vertical className={css.pane}>
        <BasicSelfiesPanel />
      </Vertical>
    </Vertical>
  )
})
